// src/constants/breakpoints.ts

export type TailwindBreakpoint = "sm" | "md" | "lg" | "xl" | "2xl";

export const BREAKPOINTS: Record<TailwindBreakpoint, string> = {
  sm: "(min-width: 640px)",
  md: "(min-width: 768px)",
  lg: "(min-width: 1024px)",
  xl: "(min-width: 1280px)",
  "2xl": "(min-width: 1536px)",
};
